







































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { AddAttorneyRequest, ApiRequest, UpdateAttorneyRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import '../../assets/css/AddPatientModal.scss';
@Component({
    mixins: [validationMixin],
    props: {
        organizationId: {
            required: true,
        },
        memberId: {
            required: true,
        },
        attorney: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            firmName: '',
        };
    },
    validations: {
        fullName: {
            required,
            regex: (fullName) => /^[a-zA-Z ]+$/.test(fullName),
        },
        email: {
            required,
            email,
        },
        phone: {
            required,
            minLength: minLength(10),
            regex: (phone) =>
                MedTransGoConstants.PHONE_REGX.test(phone),
        },
        firmName: {
            required,
            regex: (firmName) => /^[a-zA-Z ]+$/.test(firmName),
        },
    },
})
export default class AddAttorneyModal extends Vue {
    private show = true;

    public mounted() {
        if (this.$props.attorney) {
            const attorney = this.$props.attorney;
            this.$data.fullName = attorney.name;
            this.$data.email = attorney.email;
            this.$data.phone = attorney.phoneNo;
            this.$data.firmName = attorney.firmName;
            this.$props.organizationId = attorney.organizationId;
        }
    }
    private async addAttorney() {
        const iHttpService = ObjectFactory.getHttpService();
        const addAttorneyRequest: AddAttorneyRequest = {
            name: this.$data.fullName,
            email: this.$data.email,
            phoneNo: this.$data.phone,
            firmName: this.$data.firmName,
            organizationId: this.$props.organizationId,
            status: 'ACTIVE',
            memberId: this.$props.memberId,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ATTORNEY}`,
            data: addAttorneyRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<any>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_ATTORNEY'),
                title: 'Success!',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async updateAttorney() {
        const iHttpService = ObjectFactory.getHttpService();
        const updateAttorneyRequest: UpdateAttorneyRequest = {
            name: this.$data.fullName,
            email: this.$data.email,
            phoneNo: this.$data.phone,
            firmName: this.$data.firmName,
            organizationId: this.$props.organizationId,
            status: 'ACTIVE',
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ATTORNEY}/${this.$props.attorney.id}`,
            data: updateAttorneyRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_ATTORNEY'),
                title: 'Success!',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
            replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }

    private close() {
        this.$emit('close');
    }
}
